import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getMasterCameraNvrList } from "../../redux/actions/MasterActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import Preloader from "../../Components/Preloader";
import { getCameraListById, saveCameraData, updateCameraData } from "../../redux/actions/CameraActions";

const ViewVideo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
    const [fieldErrors, setFieldErrors] = useState({});
  
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    cameraReducer: {
      loadingCamera,
      errorsCamera,
      cameraLists,
      changedCameraStatus,
    },
    masterReducer: {
      masterCameraNvrLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getMasterCameraNvrList(auth?.accessToken));
    }
  }, [auth?.accessToken]);

  useEffect(() => {
    if (id) {
      dispatch(getCameraListById(auth?.accessToken, id));
    }
  }, [auth, id]);


  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
      const updatedpayload={ id: formData.id,
           nvrId: formData?.nvrId,
          cameraId: formData?.cameraId,
          cameraName: formData?.cameraName,
          cameraChannel:Number(formData?.cameraChannel),
          status: formData?.status,
}
      dispatch(updateCameraData(auth?.accessToken, updatedpayload, id));
    }
    else {
const payload={
           nvrId: formData?.nvrId,
          cameraId: formData?.cameraId,
          cameraName: formData?.cameraName,
          cameraChannel:Number(formData?.cameraChannel),
          status: formData?.status,
}

      // console.log('formData', formData);
      dispatch(saveCameraData(auth?.accessToken, payload));
    }
  };

  useEffect(() => {
    if (id) {
      if (cameraLists && Object.keys(cameraLists).length > 0) {
        setFormData({
          "nvrId": cameraLists?.nvr?.id,
          "cameraId": cameraLists?.cameraId,
          "cameraName": cameraLists?.cameraName,
          "cameraChannel": cameraLists?.cameraChannel,
          "status": cameraLists?.status,
        });
      }
    }

  }, [cameraLists])

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errorsCamera?.status === 401) {
        dispatch(logout());
        toast.error(errorsCamera?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errorsCamera, dispatch, navigate]);

  useEffect(() => {
    if (errorsCamera && Object.keys(errorsCamera).length > 0) {
      if (errorsCamera?.status === 401) {
        dispatch(logout())
        toast.error(errorsCamera?.data?.message);
        navigate('/login');
        //window.location.reload();
      }
      else if (errorsCamera?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsCamera?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      } else if (errorsCamera?.status === 400) {
        // Handle other status
         if (errorsCamera?.data?.errors && Array.isArray(errorsCamera.data.errors)) {
          const transformedErrors = {};
          errorsCamera.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      } else {
        dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      }
    }
  }, [errorsCamera, dispatch]);

  useEffect(() => {
    if (errorsCamera && Object.keys(errorsCamera).length > 0) {
      if (errorsCamera?.status === 401) {
        dispatch(logout())
        toast.error(errorsCamera?.data?.message);
        navigate('/login');
      }
    }
  }, [errorsCamera]);

  useEffect(() => {
    if (changedCameraStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedCameraStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
      navigate(-1);
    }
  }, [changedCameraStatus, dispatch, navigate]);

  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_CAMERA_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0]?.nvrId
    }));
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
    useEffect(() => { 
      console.log('fieldErrors', fieldErrors);
    },[fieldErrors]);

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsCamera?.data?.nvr_id ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsCamera?.data?.nvr_id ? 'red' : base.borderColor,
      }
    }),
  };
useEffect(() => {
    setFieldErrors({});
},[(navigate)]);
  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Camera"), path: "Camera" },
            { label: id ? t("Update Camera") : t("Add Camera"), path: "/Add-Camera", active: true },
        ]}
        title={id ? t("Update Camera") : t("Add Camera")}
      />

      <Row>
        <Col lg={4}></Col>
        <Col lg={4}>
          <Card>
            <Card.Body>
              {errorsCamera?.data?.message && (
                <div className="alert alert-danger">
                  {errorsCamera?.data?.message}
                </div>
              )}

              <Form.Group className="mb-3">
                <Form.Label>{t("Nvr")}</Form.Label>
                <Select
                  className={fieldErrors?.nvrId ? "border-danger" : ""}
                  options={masterCameraNvrLists}
                  values={masterCameraNvrLists.filter((nvr) => nvr?.nvrId === formData.nvrId)}
                  name="nvrId"
                  labelField={"nvrName"}
                  valueField={"nvrId"}
                  onChange={(selectedData) => selectHandler(selectedData, "nvrId")}
                  styles={customSelectStyles}
                />

                {fieldErrors?.nvrId && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{fieldErrors?.nvrId}</p>
                  </div>
                )}
              </Form.Group>

               <FormInput
                label={t("Camera ID")}
                type="text"
                errors={fieldErrors}
                value={formData.cameraId}
                name="cameraId"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />

              <FormInput
                label={t("Camera Name")}
                type="text"
                errors={fieldErrors}
                value={formData.cameraName}
                name="cameraName"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />

              <FormInput
                label={t("Channel")}
                type="text"
                errors={fieldErrors}
                value={formData.cameraChannel}
                name="cameraChannel"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />

              <div className="d-flex justify-content-center">
                {loading ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingCamera && (<Preloader />)}
      {loadingMaster && (<Preloader />)}
    </>
  );
};

export default ViewVideo;
